import { jsx as _jsx } from "react/jsx-runtime";
import { BiolinkLayout } from '@app/short-links/renderers/biolink-renderer/biolink-layout';
export function BiolinkRenderer({ biolink }) {
    return (_jsx(BiolinkLayout, { biolink: biolink, enableLinkAnimations: true, showAds: true, className: "max-w-680 mx-auto" }));
}
